import { render, staticRenderFns } from "./AUsuariosActivos2.vue?vue&type=template&id=0c0770b4"
import script from "./AUsuariosActivos2.vue?vue&type=script&lang=js"
export * from "./AUsuariosActivos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports